import {defaultImage, defaultWhatsAppImage} from '../../../assets/symbols/images/defaultImage';
import {givechakImage} from '../../../assets/symbols/images/givechakImage';
import {isImagePathSupported} from './whatsAppValidation';

export const getWhatsAppImagePath = (image, defaultFbImage, eventType) => {
    if(image?.path && isImagePathSupported(image.path)) {
        return image.path;
    }
    if(defaultFbImage.path === defaultImage) {
        return eventType === 'givechak' ? givechakImage : defaultWhatsAppImage;
    }
    if(defaultFbImage.path) {
        return defaultFbImage.path;
    }
    return eventType === 'givechak' ? givechakImage : defaultWhatsAppImage;
};
